import { isSSR } from "../is-ssr.js";
const baseDecodedInstance = {
  instanceId: "",
  appDefId: "",
  metaSiteId: "",
  uid: "",
  siteOwnerId: ""
};
function splitInstance(instance) {
  console.assert(instance, "instance is mandatory");
  const splitted = instance.split(".");
  console.assert(splitted.length >= 2, "instance must contain data and signature separated by .");
  const data = splitted.reduce(
    (longest, current) => current.length > longest.length ? current : longest,
    ""
  );
  return data;
}
function parseInstance(instance) {
  if (!instance) {
    return baseDecodedInstance;
  }
  try {
    const data = splitInstance(instance);
    const bit64Data = isSSR() ? (
      // Accessing 'Buffer' via 'global' prevents webpack polyfilling it for web environment
      global.Buffer.from(data, "base64").toString("utf8")
    ) : atob(data);
    const decodedInstance = JSON.parse(bit64Data);
    if (decodedInstance.data) {
      return {
        ...baseDecodedInstance,
        ...JSON.parse(decodedInstance.data).instance
      };
    }
    return {
      ...baseDecodedInstance,
      ...decodedInstance
    };
  } catch (error) {
    return baseDecodedInstance;
  }
}
export {
  parseInstance
};
//# sourceMappingURL=parse-instance.js.map
